// @flow
import type { Action, SessionState, CastButtonState } from 'Common/cast/types';
import type { ThunkAction, State as AppState } from 'Common/types';
import type { SourceType } from 'Common/player/types';

export const setCastSessionState = (
  castSessionState: SessionState,
  deviceName?: string,
  error?: string,
): ThunkAction => ({ dispatch }) => {
  if (
    castSessionState === 'CAST_SESSION_START_FAILED' ||
    castSessionState === 'CAST_SESSION_RESUME_FAILED'
  ) {
    setTimeout(() => dispatch(setCastSessionState('CAST_SESSION_DISCONNECTED')), 5000);
  }
  dispatch({
    isGoogleCastAction: true,
    type: castSessionState,
    deviceName,
    error,
  });
};

export const castButtonStateChanged = (buttonState: CastButtonState): Action => ({
  isGoogleCastAction: true,
  type: 'CAST_BUTTON_STATE_CHANGED',
  buttonState,
});

export const setPlayingOnCastDevice = (isPlaying: boolean, error?: string): Action => ({
  isGoogleCastAction: true,
  type: 'CAST_PLAYING_ON_CAST_DEVICE',
  isPlaying,
  error,
});

export const resetStore = (payload: $Shape<AppState>): Action => {
  /* Remove enterprise token since it can't be shared between sender and receiver */
  const viewer = payload.auth?.viewer || {};
  if (typeof viewer.enterprise === 'string') delete viewer.enterprise;

  /* Receiver have to sign in itself */
  if (payload.auth?.signInType) payload.auth.signInType = 'none';

  /* Source type must be empty (otherwise it may break logic in hooks) */
  if (payload.player?.sourceType) {
    delete payload.player?.sourceType;
  }

  return { isGoogleCastAction: true, type: 'CAST_SET_STORE', payload };
};

export const setStoreHasBeenSynced = (payload: boolean): Action => ({
  isGoogleCastAction: true,
  type: 'CAST_STORE_HAS_BEEN_SYNCED',
  payload,
});

export const setCastSourceType = (payload: SourceType): Action => ({
  isGoogleCastAction: true,
  type: 'CAST_SET_SOURCE_TYPE',
  payload,
});

export const setVideoProgress = (progress: number): Action => ({
  isGoogleCastAction: true,
  type: 'CAST_SET_VIDEO_PROGRESS',
  progress,
});
